import { SURF_APP_ID } from "../constants.js";
import { SURF_AGENT_MODEL_ID } from "../graphql/surfApi.js";
function bedrockConverseUrl(cfg) {
    const base = cfg.bedrockProxyUrl?.replace(/\/+$/, "") ?? "";
    if (!base)
        return "/bedrock/converse";
    return `${base}/bedrock/converse`;
}
function extractConverseText(json) {
    const output = json.output;
    const message = output?.message;
    const content = message?.content;
    if (!Array.isArray(content))
        return "";
    return content
        .map((block) => {
        if (block && typeof block === "object" && "text" in block) {
            return String(block.text ?? "");
        }
        return "";
    })
        .filter(Boolean)
        .join("");
}
/**
 * Sync Bedrock Converse — stesso percorso di Pulse `vida.ai.chat` → POST /bedrock/converse.
 */
export async function surfBedrockChat(cfg, opts) {
    if (!cfg.bedrockProxyUrl?.trim() && typeof globalThis.location === "undefined") {
        throw new Error("Bedrock proxy non configurato.");
    }
    const token = await cfg.getIdToken();
    const url = bedrockConverseUrl(cfg);
    let res;
    try {
        res = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                "x-oidc-token": token,
                "X-Vida-AppId": SURF_APP_ID,
                "X-Vida-Feature": opts.feature,
            },
            body: JSON.stringify({
                model: opts.modelId ?? SURF_AGENT_MODEL_ID,
                system: [{ text: opts.systemText }],
                messages: [{ role: "user", content: [{ text: opts.userText }] }],
                inferenceConfig: { maxTokens: opts.maxTokens ?? 8192 },
            }),
        });
    }
    catch (e) {
        if (e instanceof TypeError) {
            const configured = Boolean(cfg.bedrockProxyUrl?.trim());
            throw new Error(configured
                ? "Impossibile contattare Bedrock proxy (rete o CORS). Verifica che l'API Gateway bedrock-proxy abbia CORS abilitato."
                : "Impossibile contattare Bedrock proxy: URL non configurato. In produzione verifica vida-cloud-surf-config.json; in locale VITE_BEDROCK_PROXY_URL e riavvia il dev server.");
        }
        throw e;
    }
    const text = await res.text();
    if (!res.ok) {
        throw new Error(`Bedrock converse (${res.status}): ${text.slice(0, 300)}`);
    }
    let json;
    try {
        json = JSON.parse(text);
    }
    catch {
        throw new Error("Risposta Bedrock non JSON.");
    }
    const out = extractConverseText(json).trim();
    if (!out) {
        throw new Error("Il modello non ha restituito testo.", { cause: text.slice(0, 200) });
    }
    return out;
}
export function isAsyncFallbackError(e) {
    if (!(e instanceof Error))
        return false;
    const msg = e.message.toLowerCase();
    return (msg.includes("503") ||
        msg.includes("timeout") ||
        msg.includes("timed out") ||
        msg.includes("e_empty_output"));
}
